import React, { useCallback, useState } from 'react';
import { useInternalMailCreate } from '../hooks/use-internal-mail-create.js';
import { useInternalMailList } from '../hooks/use-internal-mail-list.js';
import InternalMailPageView from './internal-mail-page-view.jsx';

function InternalMailPageContainer() {
  const { messages, isLoading, error, reload } = useInternalMailList();
  const [isCreateOpen, setIsCreateOpen] = useState(false);

  const openCreate = useCallback(() => setIsCreateOpen(true), []);
  const closeCreate = useCallback(() => setIsCreateOpen(false), []);

  const handleCreateSuccess = useCallback(() => {
    setIsCreateOpen(false);
    reload();
  }, [reload]);

  const createHook = useInternalMailCreate({ onSuccess: handleCreateSuccess });

  return (
    <InternalMailPageView
      messages={messages}
      isLoading={isLoading}
      error={error}
      isCreateOpen={isCreateOpen}
      openCreate={openCreate}
      closeCreate={closeCreate}
      createHook={createHook}
    />
  );
}

export default InternalMailPageContainer;
